import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

function PageNotFound() {
  return (
    <div className='flex flex-col justify-center items-center w-full h-screen bg-gray-100 p-4'>
      <div className='w-full flex justify-center'>
        <img
          src="https://cdni.iconscout.com/illustration/premium/thumb/connection-error-7621865-6167019.png"
          alt="Page Not Found"
          className='max-w-full h-auto'
        />
      </div>
      <div className='text-center mt-4'>
        {/* <h1 className='text-4xl font-bold text-gray-800 mb-2'>404</h1> */}
        <p className='text-lg text-gray-600 mb-4'>Oops! The page you're looking for doesn't exist.</p>
        <Link
          className='px-4 py-2 bg-white border rounded border-blue-500 border-dashed flex flex-row items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 shadow-lg transform hover:scale-105'
          to={'/'}
        >
          <span className='me-1'>Click here to redirect to home page</span>
          <Icon icon="fluent-mdl2:navigate-external-inline" className='text-lg text-blue-700'/>
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
